import React, { useState } from 'react';

const STEPS = ['online', 'accept', 'otp', 'cash'];

export default function FirstTimeTour({ t, onDone }) {
  const [i, setI] = useState(0);
  const key = STEPS[i];

  const next = () => {
    if (i >= STEPS.length - 1) {
      localStorage.setItem('mt_driver_tour_done', '1');
      onDone?.();
      return;
    }
    setI((n) => n + 1);
  };

  return (
    <div className="modal-backdrop" role="presentation" onClick={next}>
      <div className="modal-sheet" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="tour-step">{i + 1}/{STEPS.length}</div>
        <h3>{t(`tour.${key}.title`)}</h3>
        <p className="text-muted">{t(`tour.${key}.body`)}</p>
        <button type="button" className="btn btn-green" onClick={next}>
          {i >= STEPS.length - 1 ? t('tour.done') : t('tour.next')}
        </button>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={() => {
            localStorage.setItem('mt_driver_tour_done', '1');
            onDone?.();
          }}
        >
          {t('tour.skip')}
        </button>
      </div>
    </div>
  );
}
